import { deepCopyClassName, WebCoreSettings } from '@lmnop/web-core';
import { IWebsiteCoreSettings } from './website-core-settings.interface';

export enum BackgroundType {
    NATIVE_PARTICLE = 'nativeParticle',
    FIRE_FLY = 'firefly',
    PARTICLES_JS = 'particlesJs',
}
export class WebsiteCoreSettings extends WebCoreSettings implements IWebsiteCoreSettings {
    constructor() {
        super();
    }

    backGroundType: BackgroundType;

    public override init() {
        super.init();
    }

    public override setDefaultValues(): void {
        super.setDefaultValues();
    }

    public override translateDefaultValues(): void {
        super.translateDefaultValues();
    }
}
